'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterAll = filterAll;

var _constants = require('../constants');

function filterAll(listIds, establishments, selectedProps) {
  return listIds.filter(function (id) {
    return filterEstablishment(establishments[id], selectedProps);
  });
}

function filterEstablishment(establishment, selectedProps) {
  return [byPriceRange, byAvailability, byServices, byRooms, byEstablishmentType, byZones, byRecommendation, byReviews, byDiscount, byCancellation, byRating, byStars].every(function (fn) {
    return fn(establishment, selectedProps);
  });
}

function byPriceRange(estabProps, selectedProps) {
  var priceRange = selectedProps.priceRange;


  if (!priceRange || !priceRange.type || !priceRange.applied || !Object.keys(priceRange.applied).length) return true;
  var estabPropType = priceRange.type === _constants.PRICE_FILTER_TYPE.DAY ? 'minDayPrice' : 'minTotalPrice';

  return Object.keys(priceRange.applied).some(function (key) {
    var range = priceRange.applied[key];

    if (!range[1]) return estabProps[estabPropType] >= Number(range[0]);
    return estabProps[estabPropType] >= Number(range[0]) && estabProps[estabPropType] <= Number(range[1]);
  });
}

function byAvailability(estabProps, selectedProps) {
  var availability = estabProps.availability;
  var availabilityFilterApplied = selectedProps.availabilityFilterApplied;

  if (!availabilityFilterApplied || !availabilityFilterApplied.length) return true;
  return !!~availabilityFilterApplied.indexOf(availability);
}

function byServices(estabProps, selectedProps) {
  var features = estabProps.features;
  var servicesFilterApplied = selectedProps.servicesFilterApplied;

  if (!servicesFilterApplied || !servicesFilterApplied.length) return true;
  return servicesFilterApplied.every(function (feature) {
    return features && ~features.indexOf(feature);
  });
}

function byRooms(estabProps, selectedProps) {
  var rooms = estabProps.rooms;
  var roomsSelected = selectedProps.roomsSelected;

  return !roomsSelected || roomsSelected === 0 || rooms && roomsSelected <= rooms;
}

function byEstablishmentType(estabProps, selectedProps) {
  var category = estabProps.category;
  var typeFilterApplied = selectedProps.typeFilterApplied;

  return !typeFilterApplied || !typeFilterApplied.length || !!~typeFilterApplied.indexOf(category);
}

function byZones(estabProps, selectedProps) {
  var polygons = estabProps.polygons;
  var zonesFilterApplied = selectedProps.zonesFilterApplied;

  if (!polygons || !zonesFilterApplied || !zonesFilterApplied.length) return true;
  return polygons.some(function (zoneId) {
    return ~zonesFilterApplied.indexOf(zoneId);
  });
}

function byRecommendation(estabProps, selectedProps) {
  var recommendation = estabProps.recommendation;
  var recommendationSelected = selectedProps.recommendationSelected;

  if (!recommendationSelected) return true;
  return recommendation;
}

function byReviews(estabProps, selectedProps) {
  var ranking = estabProps.ranking;
  var reviewsSelected = selectedProps.reviewsSelected;

  if (!reviewsSelected) return true;
  return ranking && ranking >= _constants.RANKING_LOW_LIMIT.POSITIVE;
}

function byDiscount(estabProps, selectedProps) {
  var discount = estabProps.discount;
  var discountSelected = selectedProps.discountSelected;

  if (!discountSelected) return true;
  return discount && discount >= 10;
}

function byCancellation(estabProps, selectedProps) {
  var cancellationPolicy = estabProps.cancellationPolicy;
  var cancellationSelected = selectedProps.cancellationSelected;

  return !cancellationSelected || cancellationPolicy && cancellationPolicy === _constants.CANCELLATION_POLICY.FULL;
}

function byRating(estabProps, selectedProps) {
  var combinedRating = estabProps.combinedRating;
  var ratingSelected = selectedProps.ratingSelected;

  return !ratingSelected || combinedRating >= ratingSelected;
}

function byStars(estabProps, selectedProps) {
  var category = estabProps.category,
      stars = estabProps.stars;
  var typeFilterApplied = selectedProps.typeFilterApplied,
      starsSelected = selectedProps.starsSelected;

  if (!starsSelected || !starsSelected.length) return true;
  if (_constants.HOTEL_CATEGORIES.includes(category)) {
    return starsSelected.includes(stars) && typeFilterApplied.includes(category);
  }
  return !typeFilterApplied || typeFilterApplied.includes(category);
}